import { mutations as cityMutations, actions as cityActions } from './store/city.store';
// See https://jira.boxberry.ru/browse/NSITE-514 https://jira.accurateweb.ru/browse/BOXBERRY-441
// import initPWA from './helpers/pwa';

export default {
  init() {
    // Загрузим город пользователя и сохраним в LocalStorage, чтобы не загружать каждый раз до явного подтверждения
    cityActions
      .load()
      .then((city) => {
        cityMutations.setCity(city);
        if (typeof city.Confirmed !== 'undefined' && city.Confirmed) {
          cityMutations.confirm();
        }
        cityActions.persist();
      });

    // See https://jira.boxberry.ru/browse/NSITE-514 https://jira.accurateweb.ru/browse/BOXBERRY-441
    //    initPWA();
  },
};
